import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/common/PageHero";
import { EnquirySection } from "@/components/home/EnquirySection";

export default function Contact() {
  useSeo("Contact & Enrol", "Enquire or enrol with MUCCI Academy. Tell us about your Years 5–10 learner and we'll reply by email about courses and learning options.");
  return (
    <div data-testid="contact-page">
      <PageHero testid="contact-hero" eyebrow="Contact" color="bg-blush" title="Let's start with your questions"
        intro="Whether you're a student, a parent or a homeschooling family, send us an enquiry and we'll get back to you by email." />
      <EnquirySection title="Enquire or enrol" />
    </div>
  );
}
